var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _path7, _g5, _path8, _g6, _path9, _path0, _g7, _path1, _g8, _path10, _path11, _g9, _g0, _path12, _circle, _circle2, _g1, _path13, _circle3, _circle4, _g10, _path14, _circle5, _circle6, _g11, _path15, _circle7, _circle8, _g12, _path16, _circle9, _circle0, _g13, _path17, _circle1, _circle10, _g14, _path18, _circle11, _circle12, _g15, _path19, _circle13, _circle14, _g16, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgLogoDeposits = function SvgLogoDeposits(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125 125",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9546 19.4028C56.7899 18.9604 57.7901 18.9604 58.6254 19.4028L83.9793 32.8304L57.29 46.9653L30.6007 32.8304L55.9546 19.4028Z",
    fill: "url(#logo-deposits_svg__paint0_linear_10099_8507)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter0_i_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6007 87.259V32.7837L57.4215 46.9431V104.009L33.0557 91.3073C31.5469 90.5208 30.6007 88.9605 30.6007 87.259Z",
    fill: "url(#logo-deposits_svg__paint1_linear_10099_8507)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4692 86.8851V49.8755L57.29 64.0349V102.099C57.29 102.956 56.381 103.507 55.6212 103.111L33.2311 91.4394C31.5337 90.5546 30.4692 88.7993 30.4692 86.8851Z",
    fill: "url(#logo-deposits_svg__paint2_linear_10099_8507)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter1_i_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9927 88.4727V32.855L57.4215 46.943V104.009L82.4547 91.0048C83.3997 90.5139 83.9927 89.5376 83.9927 88.4727Z",
    fill: "url(#logo-deposits_svg__paint3_linear_10099_8507)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8612 88.3601V33.2256L57.2901 47.3136V76.6532C57.2901 89.2865 70.6835 97.4218 81.8944 91.5981C83.1029 90.9704 83.8612 89.7219 83.8612 88.3601Z",
    fill: "url(#logo-deposits_svg__paint4_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask0_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 17,
    width: 54,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.672 18.2617C54.5074 17.8193 55.5075 17.8193 56.3428 18.2617L81.6967 31.6893L55.0074 45.8242L28.3181 31.6893L53.672 18.2617Z",
    fill: "url(#logo-deposits_svg__paint5_linear_10099_8507)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask0_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8104 24.0962L38.9937 39.2824",
    stroke: "#413AC5",
    strokeWidth: 0.570655
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5224 23.5254L40.7057 38.7116",
    stroke: "#E8DEFD",
    strokeOpacity: 0.5,
    strokeWidth: 0.228262
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask1_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 33,
    width: 27,
    height: 72
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 87.4754V33L56.8208 47.1594V104.225L32.455 91.5236C30.9462 90.7371 30 89.1768 30 87.4754Z",
    fill: "url(#logo-deposits_svg__paint6_linear_10099_8507)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask1_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter2_d_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.332 37.8467V96.4102",
    stroke: "#413AC5",
    strokeWidth: 0.570655
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0786 19.2434C56.7525 18.8722 57.5681 18.8655 58.2481 19.2256L83.8478 32.7835C83.8478 32.7835 67.7479 27.9935 57.1585 27.9935C46.5692 27.9935 43.726 26.0463 43.726 26.0463L56.0786 19.2434Z",
    fill: "url(#logo-deposits_svg__paint7_linear_10099_8507)",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.65 60.1023C80.1295 59.8484 80.7036 59.8484 81.183 60.1023L95.7359 67.8097L80.4165 75.9229L65.0971 67.8097L79.65 60.1023Z",
    fill: "url(#logo-deposits_svg__paint8_linear_10099_8507)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter3_i_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0972 99.0511V67.7827L80.4921 75.9101V108.665L66.5063 101.375C65.6403 100.923 65.0972 100.028 65.0972 99.0511Z",
    fill: "url(#logo-deposits_svg__paint9_linear_10099_8507)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0216 98.8365V77.5933L80.4165 85.7206V107.569C80.4165 108.061 79.8947 108.377 79.4586 108.15L66.6069 101.451C65.6326 100.943 65.0216 99.9352 65.0216 98.8365Z",
    fill: "url(#logo-deposits_svg__paint10_linear_10099_8507)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter4_i_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7435 99.7478V67.8237L80.4919 75.9101V108.665L94.8607 101.201C95.4032 100.919 95.7435 100.359 95.7435 99.7478Z",
    fill: "url(#logo-deposits_svg__paint11_linear_10099_8507)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6681 99.6828V68.0361L80.4165 76.1226V92.9632C80.4165 100.215 88.1042 104.884 94.5391 101.541C95.2328 101.181 95.6681 100.465 95.6681 99.6828Z",
    fill: "url(#logo-deposits_svg__paint12_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask2_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 59,
    width: 32,
    height: 17
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3398 59.447C78.8193 59.1931 79.3934 59.1931 79.8728 59.447L94.4257 67.1544L79.1063 75.2677L63.7869 67.1544L78.3398 59.447Z",
    fill: "url(#logo-deposits_svg__paint13_linear_10099_8507)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask2_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.0291 62.7959L69.9146 71.5126",
    stroke: "#413AC5",
    strokeWidth: 0.327551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0118 62.4683L70.8972 71.185",
    stroke: "#E8DEFD",
    strokeOpacity: 0.5,
    strokeWidth: 0.13102
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask3_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 67,
    width: 16,
    height: 42
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0217 99.035V67.7666L80.4166 75.894V108.649L66.4309 101.359C65.5648 100.907 65.0217 100.012 65.0217 99.035Z",
    fill: "url(#logo-deposits_svg__paint14_linear_10099_8507)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask3_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter5_d_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9521 70.5483V104.163",
    stroke: "#413AC5",
    strokeWidth: 0.327551
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7212 60.0109C80.108 59.7978 80.5762 59.794 80.9664 60.0007L95.6605 67.7828C95.6605 67.7828 86.4193 65.0334 80.3411 65.0334C74.2629 65.0334 72.6309 63.9157 72.6309 63.9157L79.7212 60.0109Z",
    fill: "url(#logo-deposits_svg__paint15_linear_10099_8507)",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6234 49.6078L30.5116 47.1787V47.8029L24.8333 50.1384C23.2366 50.7701 23.1285 52.9887 24.6562 53.7727L80.3819 82.3687C83.3512 83.8924 86.866 83.9224 89.8609 82.4495L99.6322 77.6439C100.633 77.1517 100.707 75.7531 99.7645 75.1575L95.7535 72.2655V71.6146L100.069 74.675C101.389 75.5088 101.285 77.4669 99.8841 78.156L90.1127 82.9616C86.956 84.5141 83.2511 84.4825 80.1214 82.8764L24.3956 54.2804C22.4315 53.2725 22.5705 50.4199 24.6234 49.6078Z",
    fill: "#91EEFF"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter6_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2536 60.4556L80.3818 85.7926C83.351 87.3163 86.8659 87.3462 89.8607 85.8734C96.9665 82.3787 97.1052 82.9465 90.1126 86.3855C86.9559 87.9379 83.251 87.9063 80.1212 86.3003L30.993 60.9633C30.3383 60.6273 30.7443 60.1943 31.2536 60.4556Z",
    fill: "#4C579B"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter7_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2536 73.0103L80.3818 98.3473C83.351 99.871 86.8659 99.9009 89.8607 98.4281C96.9665 94.9334 97.1052 95.5012 90.1126 98.9402C86.9559 100.493 83.251 100.461 80.1212 98.855L30.993 73.518C30.3383 73.182 30.7443 72.749 31.2536 73.0103Z",
    fill: "#4C579B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6234 61.0209L30.5116 58.5918V59.216L24.8333 61.5515C23.2366 62.1832 23.1285 64.4018 24.6562 65.1857L80.3819 93.7818C83.3512 95.3055 86.866 95.3355 89.8609 93.8626L99.6322 89.057C100.633 88.5648 100.707 87.1662 99.7645 86.5706L95.7535 83.6786V83.0277L100.069 86.0881C101.389 86.9219 101.285 88.88 99.8841 89.5691L90.1127 94.3747C86.956 95.9272 83.2511 95.8956 80.1214 94.2895L24.3956 65.6935C22.4315 64.6855 22.5705 61.833 24.6234 61.0209Z",
    fill: "#91EEFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0275,
    cy: 68.2686,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint16_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask4_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 64,
    width: 8,
    height: 9
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0274,
    cy: 68.2686,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint17_linear_10099_8507)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask4_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter8_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7506 69.7729C31.4705 71.073 31.6244 67.0157 30.4172 65.827C29.2099 64.6383 27.0986 66.7683 28.3786 65.4682C29.6587 64.1682 31.6751 64.0779 32.8824 65.2666C34.0896 66.4553 34.0306 68.4729 32.7506 69.7729Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter9_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4616 65.9536C33.9997 67.3795 29.5969 67.0577 28.4364 68.3095C27.276 69.5612 29.7975 71.9125 28.2594 70.4866C26.7212 69.0607 26.4151 66.89 27.5755 65.6383C28.7359 64.3866 30.9235 64.5277 32.4616 65.9536Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter10_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7701 70.3148C26.869 69.5643 29.0999 71.1134 30.5816 71.3087C32.0633 71.5039 32.2346 70.2713 32.1357 71.0219C32.0368 71.7724 30.7555 72.2226 29.2738 72.0273C27.7922 71.8321 26.6712 71.0654 26.7701 70.3148Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter11_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2461 69.3327C32.0385 71.357 30.6151 67.8485 29.5227 67.7365C28.4303 67.6246 28.0827 70.9515 28.2903 68.9272C28.4978 66.9028 29.5516 65.3525 30.6439 65.4645C31.7363 65.5765 32.4536 67.3083 32.2461 69.3327Z",
    fill: "#91EEFF"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3673 64.7322C29.1071 64.5685 26.5735 65.1311 26.5206 68.6915C26.761 67.4977 27.8668 65.0345 30.3673 64.7322Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.609,
    cy: 77.3638,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint18_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask5_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 73,
    width: 9,
    height: 9
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.6089,
    cy: 77.3638,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint19_linear_10099_8507)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask5_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter12_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3322 78.8681C48.0521 80.1682 48.2061 76.1109 46.9988 74.9222C45.7915 73.7335 43.6802 75.8635 44.9603 74.5635C46.2404 73.2634 48.2568 73.1731 49.464 74.3618C50.6713 75.5505 50.6123 77.5681 49.3322 78.8681Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter13_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0432 75.0488C50.5813 76.4747 46.1784 76.1529 45.018 77.4047C43.8576 78.6564 46.379 81.0077 44.8409 79.5818C43.3028 78.1559 42.9966 75.9853 44.157 74.7335C45.3175 73.4818 47.5051 73.6229 49.0432 75.0488Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter14_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3516 79.4101C43.4505 78.6595 45.6815 80.2086 47.1632 80.4039C48.6448 80.5991 48.8162 79.3665 48.7173 80.1171C48.6184 80.8676 47.3371 81.3178 45.8554 81.1226C44.3737 80.9273 43.2527 80.1606 43.3516 79.4101Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter15_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8276 78.4279C48.6201 80.4523 47.1966 76.9437 46.1042 76.8318C45.0119 76.7198 44.6643 80.0467 44.8718 78.0224C45.0793 75.998 46.1331 74.4477 47.2255 74.5597C48.3178 74.6717 49.0351 76.4035 48.8276 78.4279Z",
    fill: "#91EEFF"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9489 73.8274C45.6887 73.6637 43.1551 74.2264 43.1022 77.7867C43.3425 76.5929 44.4484 74.1298 46.9489 73.8274Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.543,
    cy: 56.5435,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint20_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask6_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 54,
    width: 5,
    height: 5
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5429,
    cy: 56.5435,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint21_linear_10099_8507)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask6_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter16_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.099 57.4031C31.3675 58.146 31.4555 55.8276 30.7656 55.1483C30.0757 54.469 28.8693 55.6862 29.6007 54.9433C30.3322 54.2004 31.4844 54.1488 32.1743 54.8281C32.8642 55.5073 32.8304 56.6602 32.099 57.4031Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter17_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9339 55.221C32.8128 56.0358 30.2969 55.8519 29.6338 56.5672C28.9707 57.2825 30.4115 58.6261 29.5326 57.8113C28.6537 56.9965 28.4787 55.7561 29.1418 55.0408C29.8049 54.3255 31.055 54.4062 31.9339 55.221Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter18_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6816 57.7125C28.7381 57.2836 30.013 58.1688 30.8596 58.2804C31.7063 58.392 31.8042 57.6876 31.7477 58.1165C31.6912 58.5454 30.959 58.8026 30.1123 58.6911C29.2657 58.5795 28.6251 58.1414 28.6816 57.7125Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter19_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8108 57.1515C31.6922 58.3082 30.8788 56.3034 30.2545 56.2394C29.6303 56.1754 29.4317 58.0765 29.5503 56.9197C29.6689 55.763 30.271 54.8771 30.8952 54.9411C31.5195 55.0051 31.9293 55.9947 31.8108 57.1515Z",
    fill: "#91EEFF"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7371 54.5225C30.017 54.4289 28.5692 54.7504 28.539 56.7849C28.6763 56.1027 29.3082 54.6952 30.7371 54.5225Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9559,
    cy: 63.3911,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint22_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask7_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 61,
    width: 6,
    height: 5
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.9559,
    cy: 63.3911,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint23_linear_10099_8507)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask7_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter20_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5122 64.2508C42.7807 64.9937 42.8687 62.6752 42.1788 61.9959C41.4889 61.3167 40.2825 62.5338 41.0139 61.7909C41.7454 61.048 42.8976 60.9965 43.5875 61.6757C44.2774 62.355 44.2436 63.5079 43.5122 64.2508Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter21_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.347 62.0686C44.2259 62.8834 41.71 62.6996 41.0469 63.4148C40.3838 64.1301 41.8246 65.4737 40.9457 64.6589C40.0668 63.8441 39.8918 62.6037 40.5549 61.8885C41.218 61.1732 42.4681 61.2538 43.347 62.0686Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter22_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0947 64.5601C40.1512 64.1313 41.4261 65.0165 42.2727 65.128C43.1194 65.2396 43.2173 64.5353 43.1608 64.9642C43.1043 65.393 42.3721 65.6503 41.5254 65.5387C40.6788 65.4271 40.0382 64.989 40.0947 64.5601Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter23_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2238 63.9991C43.1053 65.1559 42.2918 63.151 41.6676 63.087C41.0434 63.023 40.8448 64.9242 40.9634 63.7674C41.082 62.6106 41.6841 61.7247 42.3083 61.7887C42.9325 61.8527 43.3424 62.8423 43.2238 63.9991Z",
    fill: "#91EEFF"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1502 61.3701C41.4301 61.2766 39.9823 61.5981 39.9521 63.6326C40.0894 62.9504 40.7213 61.5429 42.1502 61.3701Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5244,
    cy: 85.814,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint24_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask8_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 83,
    width: 5,
    height: 6
  }, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5244,
    cy: 85.814,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint25_linear_10099_8507)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask8_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter24_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0807 86.6736C65.3492 87.4165 65.4372 85.0981 64.7473 84.4188C64.0574 83.7395 62.8509 84.9567 63.5824 84.2138C64.3139 83.4709 65.4661 83.4193 66.156 84.0986C66.8459 84.7778 66.8121 85.9307 66.0807 86.6736Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter25_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9155 84.491C66.7944 85.3058 64.2784 85.1219 63.6153 85.8372C62.9522 86.5525 64.3931 87.8961 63.5142 87.0813C62.6352 86.2665 62.4603 85.0261 63.1234 84.3108C63.7865 83.5955 65.0365 83.6762 65.9155 84.491Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter26_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6632 86.983C62.7197 86.5541 63.9945 87.4393 64.8412 87.5509C65.6879 87.6625 65.7858 86.9581 65.7293 87.387C65.6728 87.8159 64.9406 88.0731 64.0939 87.9616C63.2472 87.85 62.6067 87.4119 62.6632 86.983Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter27_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7923 86.422C65.6737 87.5787 64.8603 85.5739 64.2361 85.5099C63.6119 85.4459 63.4133 87.347 63.5319 86.1902C63.6504 85.0335 64.2526 84.1476 64.8768 84.2116C65.501 84.2756 65.9109 85.2652 65.7923 86.422Z",
    fill: "#91EEFF"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7187 83.793C63.9986 83.6994 62.5508 84.021 62.5205 86.0554C62.6579 85.3733 63.2898 83.9657 64.7187 83.793Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.054,
    cy: 80.5107,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint26_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask9_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 78,
    width: 6,
    height: 5
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.054,
    cy: 80.5107,
    r: 2.20899,
    fill: "url(#logo-deposits_svg__paint27_linear_10099_8507)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask9_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter28_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6101 81.3704C75.8786 82.1133 75.9666 79.7948 75.2767 79.1156C74.5868 78.4363 73.3804 79.6535 74.1118 78.9106C74.8433 78.1677 75.9955 78.1161 76.6854 78.7953C77.3753 79.4746 77.3415 80.6275 76.6101 81.3704Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter29_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.445 79.1883C77.3239 80.0031 74.808 79.8192 74.1449 80.5345C73.4818 81.2498 74.9226 82.5933 74.0437 81.7785C73.1648 80.9637 72.9898 79.7234 73.6529 79.0081C74.316 78.2928 75.5661 78.3735 76.445 79.1883Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter30_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1927 81.6798C73.2493 81.2509 74.5241 82.1361 75.3708 82.2477C76.2174 82.3592 76.3153 81.6549 76.2588 82.0838C76.2023 82.5127 75.4701 82.7699 74.6235 82.6583C73.7768 82.5468 73.1362 82.1087 73.1927 81.6798Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter31_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3219 81.1187C76.2033 82.2755 75.3899 80.2707 74.7657 80.2067C74.1414 80.1427 73.9428 82.0438 74.0614 80.887C74.18 79.7302 74.7821 78.8444 75.4064 78.9083C76.0306 78.9723 76.4405 79.962 76.3219 81.1187Z",
    fill: "#91EEFF"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2482 78.4897C74.5281 78.3962 73.0803 78.7177 73.0501 80.7522C73.1874 80.07 73.8193 78.6625 75.2482 78.4897Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1309,
    cy: 71.9683,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint28_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask10_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 68,
    width: 8,
    height: 8
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1307,
    cy: 71.9683,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint29_linear_10099_8507)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask10_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter32_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8541 73.4726C60.574 74.7727 60.7279 70.7154 59.5207 69.5267C58.3134 68.338 56.2021 70.468 57.4821 69.1679C58.7622 67.8679 60.7786 67.7776 61.9859 68.9663C63.1932 70.155 63.1341 72.1726 61.8541 73.4726Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter33_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5651 69.6533C63.1033 71.0792 58.7004 70.7574 57.54 72.0092C56.3795 73.2609 58.901 75.6122 57.3629 74.1863C55.8248 72.7604 55.5186 70.5898 56.679 69.338C57.8394 68.0863 60.027 68.2274 61.5651 69.6533Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter34_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8735 74.0145C55.9724 73.264 58.2033 74.8131 59.685 75.0084C61.1667 75.2036 61.338 73.971 61.2391 74.7216C61.1402 75.4721 59.8589 75.9223 58.3772 75.7271C56.8956 75.5318 55.7746 74.7651 55.8735 74.0145Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter35_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3495 73.0324C61.1419 75.0568 59.7185 71.5482 58.6261 71.4362C57.5337 71.3243 57.1861 74.6512 57.3936 72.6269C57.6012 70.6025 58.6549 69.0522 59.7473 69.1642C60.8397 69.2762 61.557 71.008 61.3495 73.0324Z",
    fill: "#91EEFF"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4707 68.4319C58.2105 68.2682 55.6769 68.8309 55.624 72.3912C55.8644 71.1974 56.9702 68.7342 59.4707 68.4319Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9462,
    cy: 94.5186,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint30_linear_10099_8507)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-deposits_svg__mask11_10099_8507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 90,
    width: 8,
    height: 9
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9461,
    cy: 94.5186,
    r: 3.86573,
    fill: "url(#logo-deposits_svg__paint31_linear_10099_8507)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-deposits_svg__mask11_10099_8507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter36_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6694 96.0229C91.3893 97.323 91.5433 93.2657 90.336 92.077C89.1287 90.8883 87.0174 93.0183 88.2975 91.7182C89.5775 90.4182 91.5939 90.3279 92.8012 91.5166C94.0085 92.7053 93.9495 94.7229 92.6694 96.0229Z",
    fill: "#BFE6F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter37_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3805 92.2036C93.9186 93.6295 89.5157 93.3077 88.3553 94.5595C87.1948 95.8112 89.7163 98.1625 88.1782 96.7366C86.6401 95.3107 86.3339 93.14 87.4943 91.8883C88.6548 90.6366 90.8423 90.7777 92.3805 92.2036Z",
    fill: "#69E3F8",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter38_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6889 96.5648C86.7878 95.8143 89.0188 97.3634 90.5004 97.5587C91.9821 97.7539 92.1535 96.5213 92.0546 97.2719C91.9557 98.0224 90.6743 98.4726 89.1927 98.2773C87.711 98.0821 86.59 97.3154 86.6889 96.5648Z",
    fill: "#27468B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo-deposits_svg__filter39_f_10099_8507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1648 95.5827C91.9572 97.607 90.5338 94.0985 89.4414 93.9865C88.349 93.8746 88.0014 97.2015 88.209 95.1772C88.4165 93.1528 89.4703 91.6025 90.5626 91.7145C91.655 91.8265 92.3723 93.5583 92.1648 95.5827Z",
    fill: "#91EEFF"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2861 90.9822C89.0258 90.8185 86.4922 91.3811 86.4393 94.9415C86.6797 93.7477 87.7855 91.2845 90.2861 90.9822Z",
    fill: "#A5F9FE",
    fillOpacity: 0.21
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter0_i_10099_8507",
    x: 30.6007,
    y: 32.7837,
    width: 26.8208,
    height: 71.7958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.570655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.285328
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter1_i_10099_8507",
    x: 57.4215,
    y: 32.855,
    width: 26.5712,
    height: 71.7245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.570655
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.285328
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter2_d_10099_8507",
    x: 40.0468,
    y: 37.5614,
    width: 1.14121,
    height: 59.1341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.142664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10099_8507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10099_8507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter3_i_10099_8507",
    x: 65.0972,
    y: 67.7827,
    width: 15.3949,
    height: 41.2099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.327551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163776
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter4_i_10099_8507",
    x: 80.4919,
    y: 67.8237,
    width: 15.2516,
    height: 41.1689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.327551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.163776
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter5_d_10099_8507",
    x: 70.7883,
    y: 70.3846,
    width: 0.655188,
    height: 33.9423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.163776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0818878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.103339 0 0 0 0 0.0686111 0 0 0 0 0.316667 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10099_8507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10099_8507",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter6_f_10099_8507",
    x: 28.9415,
    y: 58.6635,
    width: 68.045,
    height: 30.5763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.855983,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter7_f_10099_8507",
    x: 28.9415,
    y: 71.2182,
    width: 68.045,
    height: 30.5763,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.855983,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter8_f_10099_8507",
    x: 26.7778,
    y: 63.2285,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter9_f_10099_8507",
    x: 25.6689,
    y: 63.582,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter10_f_10099_8507",
    x: 25.5614,
    y: 68.9082,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter11_f_10099_8507",
    x: 24.4535,
    y: 61.6792,
    width: 11.6082,
    height: 12.0611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter12_f_10099_8507",
    x: 43.3595,
    y: 72.3237,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter13_f_10099_8507",
    x: 42.2505,
    y: 72.6772,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter14_f_10099_8507",
    x: 42.1429,
    y: 78.0034,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter15_f_10099_8507",
    x: 41.035,
    y: 70.7744,
    width: 11.6082,
    height: 12.0611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter16_f_10099_8507",
    x: 28.6859,
    y: 53.6633,
    width: 4.67172,
    height: 4.57224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter17_f_10099_8507",
    x: 28.0524,
    y: 53.8655,
    width: 4.7529,
    height: 4.88718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter18_f_10099_8507",
    x: 27.991,
    y: 56.909,
    width: 4.457,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter19_f_10099_8507",
    x: 27.3578,
    y: 52.7781,
    width: 6.63328,
    height: 6.89207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter20_f_10099_8507",
    x: 40.0991,
    y: 60.511,
    width: 4.67172,
    height: 4.57224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter21_f_10099_8507",
    x: 39.4655,
    y: 60.7131,
    width: 4.7529,
    height: 4.88718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter22_f_10099_8507",
    x: 39.4041,
    y: 63.7566,
    width: 4.457,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter23_f_10099_8507",
    x: 38.7709,
    y: 59.6257,
    width: 6.63328,
    height: 6.89207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter24_f_10099_8507",
    x: 62.6676,
    y: 82.9339,
    width: 4.67172,
    height: 4.57224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter25_f_10099_8507",
    x: 62.034,
    y: 83.1355,
    width: 4.7529,
    height: 4.88718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter26_f_10099_8507",
    x: 61.9725,
    y: 86.1795,
    width: 4.457,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter27_f_10099_8507",
    x: 61.3394,
    y: 82.0486,
    width: 6.63328,
    height: 6.89207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter28_f_10099_8507",
    x: 73.197,
    y: 77.6306,
    width: 4.67172,
    height: 4.57224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter29_f_10099_8507",
    x: 72.5635,
    y: 77.8328,
    width: 4.7529,
    height: 4.88718,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter30_f_10099_8507",
    x: 72.5021,
    y: 80.8762,
    width: 4.457,
    height: 2.49558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.34362,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter31_f_10099_8507",
    x: 71.8689,
    y: 76.7454,
    width: 6.63328,
    height: 6.89207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07995,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter32_f_10099_8507",
    x: 55.8813,
    y: 66.9282,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter33_f_10099_8507",
    x: 54.7724,
    y: 67.2817,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter34_f_10099_8507",
    x: 54.6648,
    y: 72.6079,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter35_f_10099_8507",
    x: 53.5568,
    y: 65.3789,
    width: 11.6082,
    height: 12.0611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter36_f_10099_8507",
    x: 86.6966,
    y: 89.4785,
    width: 8.17548,
    height: 8.00105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter37_f_10099_8507",
    x: 85.5877,
    y: 89.832,
    width: 8.3177,
    height: 8.55183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter38_f_10099_8507",
    x: 85.4802,
    y: 95.1582,
    width: 7.79987,
    height: 4.36726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.601336,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "logo-deposits_svg__filter39_f_10099_8507",
    x: 84.3722,
    y: 87.9292,
    width: 11.6082,
    height: 12.0611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88991,
    result: "effect1_foregroundBlur_10099_8507"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint0_linear_10099_8507",
    x1: 64.8401,
    y1: 20.0545,
    x2: 53.427,
    y2: 44.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint1_linear_10099_8507",
    x1: 44.0111,
    y1: 39.4568,
    x2: 44.0111,
    y2: 98.2344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint2_linear_10099_8507",
    x1: 43.8796,
    y1: 54.3507,
    x2: 43.8796,
    y2: 98.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint3_linear_10099_8507",
    x1: 70.7071,
    y1: 40.5981,
    x2: 70.7071,
    y2: 96.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint4_linear_10099_8507",
    x1: 70.5756,
    y1: 39.8921,
    x2: 82.6333,
    y2: 83.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint5_linear_10099_8507",
    x1: 62.5575,
    y1: 18.9133,
    x2: 51.1444,
    y2: 42.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6132AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint6_linear_10099_8507",
    x1: 43.4104,
    y1: 39.6732,
    x2: 43.4104,
    y2: 98.4507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint7_linear_10099_8507",
    x1: 68.0026,
    y1: 21.9395,
    x2: 48.9265,
    y2: 37.4136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint8_linear_10099_8507",
    x1: 84.7502,
    y1: 60.4764,
    x2: 78.1991,
    y2: 74.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint9_linear_10099_8507",
    x1: 72.7946,
    y1: 71.613,
    x2: 72.7946,
    y2: 105.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint10_linear_10099_8507",
    x1: 72.7191,
    y1: 80.162,
    x2: 72.7191,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#413AC5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27468B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint11_linear_10099_8507",
    x1: 88.1177,
    y1: 72.2682,
    x2: 88.1177,
    y2: 104.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88C1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint12_linear_10099_8507",
    x1: 88.0423,
    y1: 71.8626,
    x2: 94.9633,
    y2: 96.6531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint13_linear_10099_8507",
    x1: 83.44,
    y1: 59.8211,
    x2: 76.889,
    y2: 73.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BE8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6132AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint14_linear_10099_8507",
    x1: 72.7192,
    y1: 71.5969,
    x2: 72.7192,
    y2: 105.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C4DB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint15_linear_10099_8507",
    x1: 86.5655,
    y1: 61.5584,
    x2: 75.6159,
    y2: 70.4404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCD4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint16_linear_10099_8507",
    x1: 30.0275,
    y1: 64.4028,
    x2: 30.0275,
    y2: 72.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint17_linear_10099_8507",
    x1: 30.0274,
    y1: 64.4028,
    x2: 30.0274,
    y2: 72.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint18_linear_10099_8507",
    x1: 46.609,
    y1: 73.498,
    x2: 46.609,
    y2: 81.2295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint19_linear_10099_8507",
    x1: 46.6089,
    y1: 73.498,
    x2: 46.6089,
    y2: 81.2295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint20_linear_10099_8507",
    x1: 30.543,
    y1: 54.3345,
    x2: 30.543,
    y2: 58.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint21_linear_10099_8507",
    x1: 30.5429,
    y1: 54.3345,
    x2: 30.5429,
    y2: 58.7525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint22_linear_10099_8507",
    x1: 41.9559,
    y1: 61.1821,
    x2: 41.9559,
    y2: 65.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint23_linear_10099_8507",
    x1: 41.9559,
    y1: 61.1821,
    x2: 41.9559,
    y2: 65.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint24_linear_10099_8507",
    x1: 64.5244,
    y1: 83.605,
    x2: 64.5244,
    y2: 88.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint25_linear_10099_8507",
    x1: 64.5244,
    y1: 83.605,
    x2: 64.5244,
    y2: 88.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint26_linear_10099_8507",
    x1: 75.054,
    y1: 78.3018,
    x2: 75.054,
    y2: 82.7197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint27_linear_10099_8507",
    x1: 75.054,
    y1: 78.3018,
    x2: 75.054,
    y2: 82.7197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint28_linear_10099_8507",
    x1: 59.1309,
    y1: 68.1025,
    x2: 59.1309,
    y2: 75.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint29_linear_10099_8507",
    x1: 59.1307,
    y1: 68.1025,
    x2: 59.1307,
    y2: 75.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint30_linear_10099_8507",
    x1: 89.9462,
    y1: 90.6528,
    x2: 89.9462,
    y2: 98.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C579B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-deposits_svg__paint31_linear_10099_8507",
    x1: 89.9461,
    y1: 90.6528,
    x2: 89.9461,
    y2: 98.3843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6468A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671859"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDeposits);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/logo-deposits.7d1c170e.svg";